<template>
  <div>
  <Dialog :title="$t('Servicio')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <ValidationObserver ref="validationObserver">
        <v-form ref="form" lazy-validation v-if="servicio" class="pa-1">
          <v-tabs v-model="active_tab" class="elevation-2 pa-2" grow>
            <!-- Cabecera del tab Datos básicos -->
            <v-tab href="#tab-datosbasico">
              <span class="tab_title">
                {{ $t("Datos básicos") }}
              </span>
            </v-tab>
            <!-- Contenido del tab Datos básicos -->
            <v-tab-item value="tab-datosbasico" class="pa-4 grey lighten-5">
              <!-- REFERENCIA FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <v-text-field
                      hide-details
                      v-model="servicio.ref"
                      :label="$t('Referencia')"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- FIN REFERENCIA FIELD -->

              <!-- NOMBRE FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Nombre').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">

                      <v-text-field
                          hide-details
                          v-model="servicio.nombre"
                          :label="$t('Nombre')"
                          outlined
                          dense
                      ></v-text-field>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN NOMBRE FIELD -->

              <!-- CATEGORÍA FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="11" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Categoría').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">

                      <v-autocomplete
                          hide-details
                          :label="$t('Categoría')"
                          v-model="servicio.categoria"
                          :items="data_form.categorias"
                          :no-data-text="$t('No hay datos')"
                          dense
                          outlined
                      ></v-autocomplete>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
                <v-col class="d-flex pa-0 align-center justify-center">
                  <v-btn
                      fab
                      depressed
                      x-small
                      color="primary"
                      :title="$t('Nueva categoría')"
                      @click="click_nueva_categoria"
                  >
                    <v-icon small>mdi-auto-fix</v-icon>
                  </v-btn>
                </v-col>
              </v-row>


              <!-- FIN CATEGORÍA FIELD -->

              <!-- CENTROS FIELD -->
              <v-row class="ma-0 mt-3" v-if="data_form.centros">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Centros').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <CustomSelect
                          :label="$t('Centros')"
                          v-model="servicio.centros"
                          :items="data_form.centros"
                      />
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN CATEGORÍA FIELD -->

              <!-- DURACIÓN FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Duración').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">

                      <v-text-field
                          hide-details
                          v-model="servicio.duracion"
                          :label="$t('Duración (Horas:Minutos)')"
                          type="time"
                          :outlined="true"
                          :dense="true"
                      />
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN DURACIÓN FIELD -->

              <!-- PRECIO FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Precio').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <v-text-field
                          hide-details
                          v-model="servicio.precio"
                          :label="$t('Precio')"
                          type="number"
                          :outlined="true"
                          :dense="true"
                      ></v-text-field>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN PRECIO FIELD -->

              <!-- IMPUESTO FIELD -->
              <v-row class="ma-0 mt-3">
                <v-col cols="12" class="pa-0">
                  <ValidationProvider rules="required"
                                      :name="$t('Impuesto').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">

                      <v-autocomplete
                          hide-details
                          :label="$t('Impuesto')"
                          v-model="servicio.impuesto"
                          :items="data_form.impuestos"
                          :no-data-text="$t('No hay datos')"
                          dense
                          outlined
                      ></v-autocomplete>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- FIN IMPUESTO FIELD -->

              <!-- ACTIVO FIELD -->
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="servicio.is_active"
                      :label="$t('Activo')"
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- FIN ACTIVO FIELD -->

            </v-tab-item>

            <!-- Cabecera del tab Tarifas -->
            <v-tab href="#tab-tarifas">
              <span class="tab_title">
                {{ $t("Tarifas") }}
              </span>
            </v-tab>
            <!-- Contenido del tab Tarifas -->
            <v-tab-item value="tab-tarifas" class="pa-4 grey lighten-5">
              <!-- ESPECIFICAR TARIFAS FIELD -->
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="servicio.is_tarifas"
                      :label="$t('Especificar tarifas')"
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- FIN ESPECIFICAR TARIFASS FIELD -->

              <div v-if="servicio.is_tarifas">
                <!-- TARIFA1 FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <ValidationProvider rules="required"
                                        :name="$t('Precio tarifa 1').toLowerCase()"
                                        v-slot="{ errors, classes }"
                    >
                      <div class="control" :class="classes">
                        <v-text-field
                            hide-details
                            v-model="servicio.precio_tarifa1"
                            :label="$t('Precio tarifa 1')"
                            type="number"
                            :outlined="true"
                            :dense="true"
                        ></v-text-field>
                      </div>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- FIN TARIFA1 FIELD -->

                <!-- TARIFA2 FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <ValidationProvider rules="required"
                                        :name="$t('Precio tarifa 2').toLowerCase()"
                                        v-slot="{ errors, classes }"
                    >
                      <div class="control" :class="classes">
                        <v-text-field
                            hide-details
                            v-model="servicio.precio_tarifa2"
                            :label="$t('Precio tarifa 2')"
                            type="number"
                            :outlined="true"
                            :dense="true"
                        ></v-text-field>
                      </div>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- FIN TARIFA2 FIELD -->

                <!-- TARIFA3 FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <ValidationProvider rules="required"
                                        :name="$t('Precio tarifa 3').toLowerCase()"
                                        v-slot="{ errors, classes }"
                    >
                      <div class="control" :class="classes">
                        <v-text-field
                            hide-details
                            v-model="servicio.precio_tarifa3"
                            :label="$t('Precio tarifa 3')"
                            type="number"
                            :outlined="true"
                            :dense="true"
                        ></v-text-field>
                      </div>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- FIN TARIFA3 FIELD -->

                <!-- TARIFA4 FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <ValidationProvider rules="required"
                                        :name="$t('Precio tarifa 4').toLowerCase()"
                                        v-slot="{ errors, classes }"
                    >
                      <div class="control" :class="classes">
                        <v-text-field
                            hide-details
                            v-model="servicio.precio_tarifa4"
                            :label="$t('Precio tarifa 4')"
                            type="number"
                            :outlined="true"
                            :dense="true"
                        ></v-text-field>
                      </div>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- FIN TARIFA4 FIELD -->
              </div>
            </v-tab-item>

            <!-- Cabecera del tab Online -->
            <v-tab href="#tab-online">
              <span class="tab_title">
                {{ $t("Online") }}
              </span>
            </v-tab>
            <!-- Contenido del tab Online -->
            <v-tab-item value="tab-online" class="pa-4 grey lighten-5">
              <!-- DISPONIBLE ONLINE FIELD -->
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="servicio.is_disponible_online"
                      :label="$t('Disponible online')"
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- FIN DISPONIBLE ONLINE FIELD -->

              <div v-if="servicio.is_disponible_online">
                <!-- USERS FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <div class="container_info_azul" v-if="!allow_save">
                      {{ $t('Puedes desasignar un empleado de este servicio desde el apartado Servicios Online de su perfil.') }}
                    </div>
                    <ValidationProvider :rules="'required'"
                                        :name="$t('Empleados').toLowerCase()"
                                        v-slot="{ errors, classes }"
                                        v-else
                    >
                      <div class="control" :class="classes">
                        <CustomSelect
                            :label="$t('Empleados')"
                            v-model="servicio.users"
                            :items="data_form.empleados"
                        />
                      </div>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- FIN USERS FIELD -->

                <!-- DESCUENTO ONLINE FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <ValidationProvider :rules="{'integer': true, 'min_value': 0, 'max_value': 100}"
                                        :name="$t('Descuento online').toLowerCase()"
                                        v-slot="{ errors, classes }"
                    >
                      <div class="control" :class="classes">
                        <v-text-field
                            hide-details
                            v-model="servicio.descuento_online"
                            :label="$t('Descuento online')"
                            type="number"
                            :outlined="true"
                            :dense="true"
                        >
                          <template v-slot:append>
                            <div style="font-size: 24px">%</div>
                          </template>
                        </v-text-field>
                      </div>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- FIN DESCUENTO ONLINE FIELD -->

                <!-- DETALLE FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <v-textarea
                        hide-details
                        v-model="servicio.detalle"
                        :label="$t('Detalle')"
                        outlined
                        dense
                    ></v-textarea>
                  </v-col>
                </v-row>
                <!-- FIN DETALLE FIELD -->
              </div>
            </v-tab-item>

            <!-- Cabecera del tab Envíos -->
            <v-tab href="#tab-envios">
              <span class="tab_title">
                {{ $t("Envíos SMS") }}
              </span>
            </v-tab>
            <!-- Contenido del tab Envíos -->
            <v-tab-item value="tab-envios" class="pa-4 grey lighten-5">
              <!-- ENVIOS SMS FIELD -->
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="servicio.is_envio_programado"
                      :label="$t('Programar envío')"
                  ></v-switch>
                </v-col>
              </v-row>
              <!-- FIN ENVIOS SMS FIELD -->

              <div v-if="servicio.is_envio_programado">

                <!-- DIAS DESPUÉS FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <ValidationProvider rules="required"
                                        :name="$t('Días después').toLowerCase()"
                                        v-slot="{ errors, classes }"
                    >
                      <div class="control" :class="classes">
                        <v-select
                            hide-details
                            v-model="servicio.dias_espera_envio_programado"
                            :label="$t('Días después')"
                            outlined
                            dense
                            :items="data_form.dias_despues"
                        ></v-select>
                      </div>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- FIN DÍAS DESPUÉS FIELD -->

                <!-- TEXTO MENSAJE FIELD -->
                <v-row class="ma-0 mt-3">
                  <v-col cols="12" class="pa-0">
                    <ValidationProvider :rules="{'required': true, 'max': 150}"
                                        :name="$t('Texto del mensaje').toLowerCase()"
                                        v-slot="{ errors, classes }"
                    >
                      <div class="control" :class="classes">
                        <v-textarea
                            hide-details
                            v-model="servicio.texto_sms_envio_programado"
                            :label="$t('Texto del mensaje')"
                            type="number"
                            :outlined="true"
                            :dense="true"
                        ></v-textarea>
                      </div>
                      <span class="error--text">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- TEXTO MENSAJE FIELD -->

              </div>
            </v-tab-item>

            <!-- Cabecera del tab Escandallo -->
            <v-tab href="#tab-escandallo">
              <span class="tab_title">
                {{ $t("Escandallo") }}
              </span>
            </v-tab>
            <!-- Contenido del tab Escandallo -->
            <v-tab-item value="tab-escandallo" class="pa-4 grey lighten-5">
              <v-row>
                <v-col cols="12" class="pa-0">
                  <div class="container_info_azul ma-0">
                    <p>
                      {{ $t('Selecciona los productos de uso interno que se pueden usar al realizar este servicio.') }}<br>
                      {{ $t('Cuando se realice una venta de este servicio el programa le mostrará los productos asociados para que pueda descontar el stock.') }}
                    </p>
                  </div>
                </v-col>
              </v-row>
              <v-row class="ma-3">
                <v-col cols="12" class="pa-0 text-center">
                  <v-chip
                      v-for="(current_producto, index) in productos_escandallo_seleccionados"
                      :key="index"
                      class="ma-2"
                      small
                      close
                      dark
                      color="green"
                      @click:close="add_product_to_escandallo(current_producto)"
                  >
                    {{ current_producto.nombre  }}
                  </v-chip>
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <Buscador @search="get_productos"/>
                  <v-data-table
                      :headers="tabla.headers"
                      :items="tabla.productos"
                      :options.sync="tabla.options"
                      :server-items-length="tabla.count"
                      :fixed-header="true"
                      class="elevation-3"
                      calculate-widths
                      :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
                  >
                    <template v-slot:item="{ item }">
                      <tr @click="add_product_to_escandallo(item)" :class="get_escandallo_class(item)">
                        <td>{{ item.nombre }}</td>
                        <td>{{ item.categoria.nombre }}</td>
                        <td>{{ item.precio }} {{ $store.state.centro.centro.divisa.simbolo }}</td>
                        <td>{{ item.barcode }}</td>
                        <td>{{ item.ref }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>

            </v-tab-item>
          </v-tabs>
        </v-form>
      </ValidationObserver>
    </template>
    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary ml-2" :disabled="!allow_save">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>

    <template v-slot:left-action v-if="active_tab==='tab-tarifas'">
      <v-btn @click="open_dialog_tarifas" small class="primary ml-2">
        <v-icon small>mdi-currency-usd</v-icon>
        {{ $t('Ver tarifas configuradas') }}
      </v-btn>
    </template>
  </Dialog>

    <FormTarifas
        v-if="dialog_tarifas"
        v-model="dialog_tarifas"
    />
    <FormCategoria
        v-if="dialog_categoria"
        v-model="dialog_categoria"
        @on_save="on_save_categoria"
        method_save="categorias/save"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FormTarifas from "@/views/Configuracion/components/FormTarifas.vue";
import FormCategoria from "@/views/Configuracion/Categorias/FormCategoria.vue";

export default {
  name: 'FormServicio',
  data() {
    return {
      dialog_tarifas: false,
      dialog_categoria: false,
      servicio: {},
      data_form: {},
      // Variable para la gestión de los chips
      productos_escandallo_seleccionados: [],
      // Model para los tabs del formulario en la validación
      active_tab: "tab-datosbasico",
      tabla: {
        productos: [],
        count: 0,
        headers: [],
        filtros: {},
        options: {
          itemsPerPage: 10
        }
      },
    }
  },
  methods: {
    /**
     * Recuperar los datos necesarios para pintar el formulario del servicio
     * @returns {Promise<void>}
     */
    async get_data_form() {
      try {
        let response = await this.$store.dispatch('servicio/get_form')
        if (response.agrupaciones) {
          let items = []
          response.agrupaciones.forEach((current_agrupacion)=>{
            items.push({'header': current_agrupacion[0]})
            items = [...items, ...current_agrupacion[1]]
          })
          response.empleados = items
        }
        this.data_form = response
        this.data_form.dias_despues = Array.from({length: 60}, (_, i) => i + 1)
      } catch (err) {
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    },

    /**
     * Recupera los productos para la tabla del escandallo
     */
    async get_productos(search = null) {
      try {
        if(search)
          this.tabla.filtros['search'] = search
        let filtros = { ...this.tabla.filtros }

        filtros['is_active'] = true

        const response = await this.$store.dispatch(
            "producto/get_productos",
            {
              params: filtros,
            }
        )
        this.tabla.productos = response.results
        this.tabla.count = response.count;
      } catch (err) {
	      this.$snotify.error(
		      this.$t("Ha ocurrido un error"),
		      this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	      )
      }
    },

    /**
     * Recupera el detalle de los productos del escandallo
     */
    async get_productos_escandallo_seleccionados(){
      if(this.servicio.productos_escandallo.length === 0) return

      try{
        const response = await this.$store.dispatch('producto/get_productos', {
          params: {
            id__in: this.servicio.productos_escandallo.join(",")
          }
        })
        this.productos_escandallo_seleccionados = response.results
      }catch (err){}
    },

    /**
     * Agrega un producto al escandallo
     * @param producto
     */
    add_product_to_escandallo(producto) {
      //Comprobamos si existe el producto
      const exist = (this.servicio.productos_escandallo.filter((el) => el === producto.id)).length > 0

      if(!exist){
        // Si no existe, lo añadimos al servicio
        this.servicio.productos_escandallo.push(producto.id)
        // y al chip
        this.productos_escandallo_seleccionados.push({
          id: producto.id,
          nombre: producto.nombre
        })
      }else{
        // Si no existe lo eliminamos del servicio
        this.servicio.productos_escandallo = this.servicio.productos_escandallo.filter((el) => el !== producto.id)
        // y del chip
        this.productos_escandallo_seleccionados = this.productos_escandallo_seleccionados.filter((el) => el.id !== producto.id)
      }
    },

    /**
     * Devuelve la clase correspondiente de la tabla escandallo
     * @param item
     * @returns {string}
     */
    get_escandallo_class(item) {
      for (let producto of this.servicio.productos_escandallo) {
        if (producto === item.id)
          return "green";
      }
      return "";
    },

    /**
     * Guarda el servicio
     * @returns {Promise<void>}
     */
    async save() {
      const form_valid = await this.$refs.validationObserver.validate()
      if (form_valid) {
        try {
          const servicio = await this.$store.dispatch('servicio/save', this.servicio)
	        this.$snotify.success(
		        this.$t("Acción realizada con éxito"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
          this.$emit('on_save', {
            servicio: servicio
          })
        } catch (err) {
	        this.$snotify.error(
		        this.$t("Ha ocurrido un error"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
        }
      }else{
        // Vamos a la pestaña que tiene el error del formulario
        for(const property in this.$refs.validationObserver.errors){
          if(property === 'nombre' && this.$refs.validationObserver.errors[property].length > 0){
            this.active_tab = 'tab-datosbasico'
            return
          }
          if(property === 'categoría' && this.$refs.validationObserver.errors[property].length > 0){
            this.active_tab = 'tab-datosbasico'
            return
          }
          if(property === 'duración' && this.$refs.validationObserver.errors[property].length > 0){
            this.active_tab = 'tab-datosbasico'
            return
          }
          if(property === 'impuesto' && this.$refs.validationObserver.errors[property].length > 0){
            this.active_tab = 'tab-datosbasico'
            return
          }
          if(property === 'precio tarifa 1' && this.$refs.validationObserver.errors[property].length > 0){
            this.active_tab = 'tab-tarifas'
            return
          }
          if(property === 'precio tarifa 2' && this.$refs.validationObserver.errors[property].length > 0){
            this.active_tab = 'tab-tarifas'
            return
          }
          if(property === 'precio tarifa 3' && this.$refs.validationObserver.errors[property].length > 0){
            this.active_tab = 'tab-tarifas'
            return
          }
          if(property === 'precio tarifa 4' && this.$refs.validationObserver.errors[property].length > 0){
            this.active_tab = 'tab-tarifas'
            return
          }
        }
      }
    },
    open_dialog_tarifas(){
      this.dialog_tarifas = true
    },

    click_nueva_categoria () {
      this.dialog_categoria = true
    },

    async on_save_categoria() {
      this.dialog_categoria = false
      await this.get_data_form()
    },
  },

  mounted() {
    this.servicio = {...this.item }
    if(!this.servicio.id){
      this.servicio.is_active = true
      this.servicio.productos_escandallo = []
      this.servicio.impuesto = this.$store.state.centro.centro.impuesto_servicios
      this.servicio.duracion = null
      this.servicio.precio = 0
      this.servicio.precio_tarifa1 = 0
      this.servicio.precio_tarifa2 = 0
      this.servicio.precio_tarifa3 = 0
      this.servicio.precio_tarifa4 = 0
      this.servicio.centros = [this.$store.state.centro.centro.id]
    }
    if(!this.servicio.impuesto){
      this.servicio.impuesto = this.$store.state.centro.centro.impuesto_servicios
    }

    this.tabla.headers = [
      { text: this.$t("Nombre"), value: "nombre", class: "primary white--text", width: "30%" },
      { text: this.$t("Categoría"), value: "categoria.nombre", class: "primary white--text" },
      { text: this.$t("Precio"), value: "precio", class: "primary white--text" },
      { text: this.$t("Código de barras"), value: "barcode", class: "primary white--text" },
      { text: this.$t("Referencia"), value: "ref", class: "primary white--text" }
    ]
    this.get_data_form()
    this.get_productos_escandallo_seleccionados()
  },

  watch: {
    'tabla.options': {
      handler(value) {
        this.tabla.filtros['limit'] = value.itemsPerPage
        this.tabla.filtros['offset'] = ((value.page - 1) * value.itemsPerPage)
        if (value.sortBy.length) {
          let desc = value.sortDesc[0] === true ? '-' : ''
          this.tabla.filtros['ordering'] = `${desc}${value.sortBy[0]
              .split(".")
              .join("__")}`;
        }
        this.get_productos()
      },
    },
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    centro(){
      return this.$store.state.centro.centro
    },
    allow_save(){
      return !(this.centro.is_servicios_compartidos && !this.centro.is_central);
    },
  },
  props: ['value', 'item'],
  components: {
    FormCategoria,
    FormTarifas,
    ValidationProvider,
    ValidationObserver
  }
}
</script>
